//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            showList: false
        };
    },
    mounted: function mounted() {
        var $el = this;

        Event.$on('show-default-list', function () {
            $el.showList = true;
        });
    },

    methods: {
        openModal: function openModal(arg, sub) {
            Event.$emit('show-defaults-modal', arg, sub);
        },
        addNewCharge: function addNewCharge() {
            Event.$emit('show-gl-wizard', false, false, { chargeScopeType: 'global', chargeScopeId: 0 });
        },
        globalLateFeeSettings: function globalLateFeeSettings() {
            Event.$emit('global-settings-late-fees');
        }
    },
    computed: {
        isAdmin: function isAdmin() {
            return (/admin/.test(window.user.role)
            );
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/GlobalDefaultsList.vue
// module id = kHlH
// module chunks = 0 1